export default "__VITE_PUBLIC_ASSET__f472141d__"